import React, { useState, useEffect, useRef } from "react";
import { BsArrowLeft, BsPlus } from "react-icons/bs";
import axios from "axios";
import { useNavigate, Link, useParams } from "react-router-dom";
import { Oval } from "react-loader-spinner"; // Importa una animación de carga de tu elección
import "react-quill/dist/quill.snow.css"; // Estilo por defecto de ReactQuill

const Addtarea = () => {
  const [formData, setFormData] = useState({
    tareas: null,
  });
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [tareas, setTareas] = useState([]);

  const navigate = useNavigate();

  const getTareas = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${window.BACKEND_URL}curso/${id}/tareas`,
        {
          headers: {
            Authorization: `${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
            "X-Rol": `${sessionStorage.getItem("role")}`,
          },
        }
      );
      setTareas(response.data);
    } catch (error) {
      console.error("Error fetching tareas:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getTareas();
        //initializeDataTable();
      } catch (error) {
        console.error("Error al obtener las tareas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, files } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleDelete = async (idTarea) => {
    try {
      await axios.delete(`${window.BACKEND_URL}curso/${id}/tareas/${idTarea}`, {
        headers: {
          Authorization: `${sessionStorage.getItem("token")}`,
          "X-Rol": `${sessionStorage.getItem("role")}`,
        },
      });

      await getTareas(); // Actualiza la lista de tareas después de eliminar
    } catch (error) {
      console.error("Error al eliminar la tarea:", error);
    }
  };

  const tablanorma = useRef(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const uploadData = new FormData();

    for (const key in formData) {
      uploadData.append(key, formData[key]);
    }

    try {
      setLoading(true);

      const response = await axios.put(
        `${window.BACKEND_URL}curso/${id}/tarea`,
        uploadData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${sessionStorage.getItem("token")}`,
            "X-Rol": `${sessionStorage.getItem("role")}`,
          },
        }
      );

      navigate("/Addtarea");
      navigate(`/Addtarea/${id}`);
    } catch (error) {
      console.error("Error al agregar la tarea:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title mb-0">Agregar Tareas</h3>
          </div>
          <div className="card-body">
            <table className="table table-bordered" ref={tablanorma}>
              <thead>
                <tr>
                  <th>Tareas</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {tareas.map((tarea) => (
                  <tr key={tarea.filename}>
                    <td>{tarea.filename}</td>
                    <td>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDelete(tarea.idTarea)}
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Archivo PDF:</label>
                    <input
                      type="file"
                      name="tareas"
                      className="form-control"
                      accept="application/pdf"
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Archivo PDF:</label>
                    <input
                      type="text"
                      name="tareas"
                      className="form-control"
                      accept="application/pdf"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between mt-2">
                <Link className="btn btn-primary" to="/Curso">
                  <BsArrowLeft style={{ fontSize: "1.6em" }} /> Regresar
                </Link>
                <button type="submit" className="btn btn-primary">
                  {loading ? (
                    <Oval
                      color="#00BFFF"
                      height={40}
                      width={40}
                      loading={loading}
                    />
                  ) : (
                    <>
                      Agregar Tarea <BsPlus style={{ fontSize: "2em" }} />
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addtarea;
